// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const configMaster = [
  {
    title: 'Buyer',
    path: '/dashboard/masters/buyer',
    icon: icon('cart'),
    ShortName: 'Masters_Buyer',
  },
  {
    title: 'Company',
    path: '/dashboard/masters/company',
    icon: icon('company'),
    ShortName: 'Masters_Company',
  },
  {
    title: 'Production Unit',
    path: '/dashboard/masters/production_unit',
    icon: icon('factorys'),
    ShortName: 'Masters_FactoryUnit',
  },
  {
    title: 'Department',
    path: '/dashboard/masters/DepartmentMst',
    icon: icon('department'),
    ShortName: 'Masters_Department',
  },
  {
    title: 'Designation',
    path: '/dashboard/masters/DesignationMst',
    icon: icon('design'),
    ShortName: 'Masters_Designation',
  },
  {
    title: 'Employee/User',
    path: '/dashboard/masters/users_access_control',
    icon: icon('employees'),
    ShortName: 'Masters_UserPreviledges',
  },
  {
    title: 'Access Settings',
    path: '/dashboard/masters/user_screen_access_control',
    icon: icon('previledges'),
    ShortName: 'Masters_AccessSettings',
  },
  {
    title: 'Control Center',
    path: '/dashboard/masters/controlcenter',
    icon: icon('controlCenter'),
    ShortName: 'Masters_ControlCenter',
  },
  {
    title: 'Factory SMV',
    path: '/dashboard/masters/factory_smv',
    icon: icon('factorySMV'),
    ShortName: 'Masters_FactorySMV',
  },
  {
    title: 'Factory Expense',
    path: '/dashboard/masters/factory_expense',
    icon: icon('factoryExpense'),
    ShortName: 'Masters_FactoryExpense',
  },
  {
    title: 'Process',
    path: '/dashboard/masters/process',
    icon: icon('processmst'),
    ShortName: 'Masters_ProcessMst',
  },

];

export default configMaster;
